export {
  createSimpleAction,
  createSimpleActionWithPayload,
  createActionsWithReducer,
  createActions,
  objectToScope,
  pipeState,
  ngrxEvent,
  scopeFactory,
  referencesToActionsFactory,
  fetchIfNotLoaded,
} from './lib/utils';

export {
  createFeatureSelector,
  memoizeSelector,
  createSelectorDeepEqual,
} from './lib/selector-utils';

export type {
  ActionScopedPayload,
  ActionsFromConfig,
  PaginationState,
  LoadedPaginationState,
} from './lib/types';
export { createEffectFactory, createFunctionalEffectFactory } from './lib/effects/factory';
export * from './lib/effects/types';

export type { SingleEntityActions } from './lib/single-entity/actions';
export { getSingleEntityActions } from './lib/single-entity/actions';
export { createSingleEntityAdapter } from './lib/single-entity/adapter';
export { createSingleEntityStore } from './lib/single-entity/factory';
export * from './lib/single-entity/types';

export { createEntityCollectionStore } from './lib/entity-collection/factory';
export { createHydratedEntityState } from './lib/entity-collection/data';
export * from './lib/entity-collection/types';

export type {
  EntityOperationAsyncPayload,
  EntityOperationSyncPayload,
  CreateOneOptimisticPayload,
  EntityUpdateOperationPayload,
} from './lib/entity-collection/actions';
export { getEntityCollectionActions } from './lib/entity-collection/actions';
export { createGenericStore } from './lib/generic/factory';
export * from './lib/generic/types';

export * from './lib/types';
export * from './lib/router';

export type { NgrxRoute } from './lib/minimal-serializer';
export { MinimalRouterStateSerializer } from './lib/minimal-serializer';

export * from './lib/facades-utils';
